export default __webpack_public_path__ + "static/media/FolderWhite.b0e7138b.svg";